import React from 'react';
  import {
    Card,
    CardBody,
    CardFooter,
    Typography,
  } from "@material-tailwind/react";
import './Services.css';
import { Link } from 'react-router-dom';

const ServiceCard = ({title,description,icon,link}) => {
  return (
    <section >
      <div className="relative">
            <Link to={link}>
            <Card className="xl:w-96 xl:h-64 shadow-2xl font-poppins hover:shadow-lg bg-white bg-opacity-80 xl:backdrop-blur-sm">  
              <CardBody className="flex flex-col items-start">
                <div className="mb-4">{icon}</div>
                <Typography variant="h5" color="blue-gray" className="mb-2 font-poppins w-full">
                  {title}
                </Typography>
                <Typography className="w-full font-poppins ">{description}</Typography>
              </CardBody>
              <CardFooter className="pt-0">
              </CardFooter>
            </Card>
            </Link>
        </div>


    </section>

  );
};

export default ServiceCard;
